import React from 'react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center px-6 pt-[120px] pb-[60px] md:px-[72px] md:py-0 overflow-hidden" data-id="element-69">
      {/* Background Gradients */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 60% at 80% 40%, rgba(184,151,58,0.055) 0%, transparent 60%), radial-gradient(ellipse 40% 50% at 10% 80%, rgba(184,151,58,0.03) 0%, transparent 60%)'
    }} data-id="element-70" />

      {/* Left Column */}
      <div className="md:pt-[100px] md:pb-[80px]" data-id="element-71">
        <div className="inline-flex items-center gap-2.5 text-[11px] font-medium tracking-[2.5px] uppercase text-gold mb-9 opacity-0 animate-fade-up" style={{
        animationDelay: '0.05s'
      }} data-id="element-72">
          <span className="inline-block w-7 h-px bg-gold" data-id="element-73"></span>
          Para dueños de negocios de reparación de crédito
        </div>

        <h1 className="font-serif text-[clamp(52px,5.5vw,82px)] font-light leading-[1.02] tracking-tight text-cream mb-8 opacity-0 animate-fade-up" style={{
        animationDelay: '0.18s'
      }} data-id="element-74">
          Llenamos tu pipeline con clientes{' '}
          <em className="italic text-gold-bright" data-id="element-75">calificados.</em> Tú cierras.
        </h1>

        <p className="text-[17px] font-light text-muted leading-relaxed max-w-[460px] mb-12 opacity-0 animate-fade-up" style={{
        animationDelay: '0.32s'
      }} data-id="element-76">
          Construimos y administramos tu sistema completo de generación de leads
          con Meta Ads — para que recibas un{' '}
          <strong className="text-cream font-normal" data-id="element-77">
            flujo predecible de clientes
          </strong>{' '}
          sin perseguir, llamar en frío ni desperdiciar dinero en leads no
          calificados.
        </p>

        <div className="flex flex-col gap-3.5 items-start opacity-0 animate-fade-up" style={{
        animationDelay: '0.46s'
      }} data-id="element-78">
          <a href="#apply" className="inline-flex items-center gap-2.5 bg-gold border border-gold text-ink text-[13px] font-semibold tracking-[1.2px] uppercase py-4 px-10 transition-all duration-250 hover:bg-gold-bright hover:-translate-y-[1px] hover:shadow-[0_16px_48px_rgba(184,151,58,0.20)]" data-id="element-79">
            Ver si Calificas →
          </a>
          <p className="text-xs tracking-wide text-[#3a3a3a]" data-id="element-80">
            Solo trabajamos con <span className="text-gold" data-id="element-81">5 negocios</span> de
            reparación de crédito a la vez.
          </p>
        </div>
      </div>
    </section>;
}